import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import PromotionForm from '../components/PromotionForm';
import createStore from '../store/Promotion';

const PromotionsApp = (props) => {
  const store = createStore(props);
  return (
    <Provider {...{ store }}>
      <PromotionForm {...props} />
    </Provider>
  );
};

// This is how react_on_rails can see the PromotionsApp in the browser.
ReactOnRails.register({ PromotionsApp });
